import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'about-us';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { aboutUs: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
